module.exports = __webpack_public_path__ + "39f837a254e3453d94ec76232ed7990e.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/InteractiveExample/de/7.m4a
// module id = 976
// module chunks = 4